export default __webpack_public_path__ + "media/siteware/favicon-152-1cda152baf90d3050f32de75d1baa399.png";